export const secureUrl = (url= '') =>{
    if(!url.startsWith('https')) return url.replace('http','https')
    return url
}